<form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()" novalidate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ isEdit ? 'Edit Tag': 'New Tag' }}</h4>
    <div aria-label="Close" (click)="onCancel()" class="close pull-right">
      <span aria-hidden="true">×</span>
    </div>
  </div>

  <div class="modal-body">
    <div class="form-group" *ngIf="tag.NAME">
      <label>Preview</label>
      <div>
        <tag [tagName]="tag.NAME" [backGroundColor]="tag.BACKGROUND_COLOR"
          [foreGroundColor]="tag.FOREGROUND_COLOR"></tag>
      </div>
    </div>

    <!-- Alert Message -->
    <crm-alert #alert></crm-alert>

    <!-- Tag Name -->
    <div class="form-group">
      <label>Name</label>
      <input type="text" name="NAME" class="form-control rounded-0"
             [(ngModel)]="tag.NAME" #NAME="ngModel"
             [ngClass]="{'is-invalid': f.submitted && NAME.invalid }" required [maxlength]="100">
      <div *ngIf="f.submitted && NAME.invalid" class="invalid-feedback">
        <div *ngIf="NAME.errors.required">Feild is required</div>
      </div>
    </div>

    <!-- Description -->
    <div class="form-group">
      <label>Description</label>
      <textarea type="text" name="DESCRIPTION" class="form-control rounded-0"
                [(ngModel)]="tag.DESCRIPTION" #DESCRIPTION="ngModel" rows="3"
                [ngClass]="{'is-invalid': f.submitted && DESCRIPTION.invalid }" required
                [maxlength]="500"></textarea>
      <div *ngIf="f.submitted && DESCRIPTION.invalid" class="invalid-feedback">
        <div *ngIf="DESCRIPTION.errors.required">Feild is required</div>
      </div>
    </div>

    <!-- Abbreviation -->
    <div class="form-group">
      <label>Abbreviation</label>
      <input type="text" name="ABBREVIATE" class="form-control rounded-0"
        [(ngModel)]="tag.ABBREVIATE" #ABBREVIATE="ngModel" [maxlength]="10">
    </div>

    <!-- Background Color -->
    <div class="form-group">
      <label>Background Color</label>
      <input type="text" name="BACKGROUND_COLOR" class="form-control rounded-0" required
             [style.background]="tag.BACKGROUND_COLOR" [(colorPicker)]="tag.BACKGROUND_COLOR" />
    </div>

    <!-- Foreground Color -->
    <div class="form-group">
      <label>Foreground Color</label>
      <input type="text" name="FOREGROUND_COLOR" class="form-control rounded-0" required
             [style.background]="tag.FOREGROUND_COLOR" [(colorPicker)]="tag.FOREGROUND_COLOR" />
    </div>

  </div>

  <div class="modal-footer">
    <div class="footer-wrapper">

    <div class="checkbox-item">
      <input class="checkbox-custom" type='checkbox' name="quickAccess" id="quickAccess" [(ngModel)]="tag.QUICK_ACCESS"/>
      <label class="checkbox-custom-label" for="quickAccess">
        Add to Quick Access
      </label>
    </div>

    <div class="checkbox-item">
      <input class="checkbox-custom" type='checkbox' name="DISPLAY_ABBR" id="DISPLAY_ABBR" [(ngModel)]="tag.DISPLAY_ABBR"/>
      <label class="checkbox-custom-label" for="DISPLAY_ABBR">
       Display Abbreviation
      </label>
    </div>

     <div class="actions">
        <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
        <button type="submit" class="btn btn-rbv" [disabled]="!f.form.valid">Submit</button>
      </div>
    </div>
  </div>
</form>
